import React from 'react';
import { Col, Container, Row } from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import CustomTableUser from './CustomTableDialectType';

export default function DialectTypeList() {
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs
            title='Dictionary'
            breadcrumbItem='Manage Dialect Type'
          />
          <Row>
            <Col className='col-12'>
              <CustomTableUser />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
